<template>
    <div>
        <Header route="/v2/values/questionnaires" name="Lista de Questionários" />
        <b-card no-body class="container-evaluation-report">
            <b-card-header class="bg-white">
                <b-row>
                    <b-container fluid class="questionnaire-title-wrapper">
                        <h3 class="questionnaire-title">
                            {{ questionnaire_title }}
                        </h3>
                    </b-container>
                </b-row>
                <b-row>
                    <b-container fluid class="list-links-wrapper">
                        <b-link href="#" @click="onChangeList('valuers')" :active="list === 'valuers'" class="list-link"
                            >{{ $t('values.report.valuers_list') }}
                        </b-link>
                        <b-link
                            href="#"
                            @click="onChangeList('evaluateds')"
                            :active="list === 'evaluateds'"
                            class="list-link"
                            >{{ $t('values.report.evaluateds_list') }}
                        </b-link>
                    </b-container>
                </b-row>
                <b-row>
                    <div class="filters">
                        <div>
                            <b-form-input
                                v-model="filtered.searchName"
                                :placeholder="$t('values.report.search_placeholder')"
                                type="search"
                                @input="onSearchName"
                                class="search-input"
                            >
                            </b-form-input>
                        </div>
                        <div>
                            <b-dropdown ref="advancedSearch" variant="light" class="align-self-center">
                                <template slot="button-content">
                                    {{ $t('form.button.filters') }}
                                </template>
                                <b-card no-body>
                                    <b-dropdown-form style="min-width: 500px">
                                        <managers
                                            :showLabel="true"
                                            :state="null"
                                            :value.sync="filtered.managers"
                                            @change="onChangeFilters"
                                        />
                                        <sections
                                            :label="$t('form.label.departmentAndUnit')"
                                            :state="null"
                                            :value.sync="filtered.sections"
                                            @change="onChangeFilters"
                                        />
                                        <occupationGroups
                                            :showLabel="true"
                                            :state="null"
                                            :value.sync="filtered.occupationGroups"
                                            @change="onChangeFilters"
                                        />
                                    </b-dropdown-form>
                                </b-card>
                            </b-dropdown>
                        </div>
                    </div>
                </b-row>
            </b-card-header>
            <EvaluationsList
                :tableItems="userList"
                :questionnaire="questionnaire"
                :list="list"
                :isLoading="isLoading"
                @update="removeItemFromTable"
                @refresh="onRefresh"
            />
            <b-card-footer class="bg-light-gray no-border">
                <div class="report-footer-content">
                    <b-pagination
                        v-model="pagination.currentPage"
                        :total-rows="pagination.total"
                        :per-page="pagination.perPage"
                        @change="onChangePageHandler"
                        v-if="pagination.total > 10 && !isLoading"
                    >
                    </b-pagination>
                    <b-form-radio-group
                        id="perPageSelector"
                        v-model="pagination.perPage"
                        :options="[10, 25, 50, 100]"
                        buttons
                        @change="onChangePerPageHandler"
                        button-variant="outline-primary"
                        v-if="pagination.total > 10 && !isLoading"
                    >
                    </b-form-radio-group>
                </div>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import EvaluationsList from './components/EvaluationsList'
import Loader from '@/views/components/loader'
import Header from '@/views/components/header'
import { Managers, Departments, OccupationGroups, SectionsWithoutLevel as Sections } from '@/views/components/fields'
import { getParam } from '@/lib/url'
import { getEvaluationsReport, getQuestionnaireTitle } from '@/views/values/api'
import { noMarginMixin } from '@/mixins'

export default {
    name: 'EvaluationsReport',
    components: {
        EvaluationsList,
        Loader,
        Managers,
        Departments,
        OccupationGroups,
        Sections,
        Header,
    },
    mixins: [noMarginMixin],
    data() {
        return {
            tableItems: [],
            isLoading: false,
            questionnaire: getParam('id', this),
            questionnaire_title: '',
            list: 'valuers',
            pagination: {
                total: null,
                perPage: 10,
                currentPage: 1,
            },
            debounce: null,
            filtered: {
                occupationGroups: [],
                sections: [],
                managers: [],
                searchName: null,
            },
        }
    },
    methods: {
        getEvaluationsReport(questionnaire, list) {
            this.isLoading = true
            this.list = list
            getEvaluationsReport(questionnaire, this.list, this.requestParameters)
                .then(({ data, total, per_page, current_page }) => {
                    this.tableItems = data
                    this.pagination = {
                        total: total,
                        perPage: per_page,
                        currentPage: current_page,
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        getQuestionnaireTitle() {
            getQuestionnaireTitle(this.questionnaire)
                .then(({ data }) => {
                    this.questionnaire_title = data.title
                })
                .catch(() => {
                    this.questionnaire_title = null
                })
        },
        onChangePageHandler(page) {
            this.pagination.currentPage = page
            this.getEvaluationsReport(this.questionnaire, this.list)
        },
        onChangePerPageHandler(perPage) {
            this.pagination.perPage = perPage
            this.pagination.currentPage = 1
            this.getEvaluationsReport(this.questionnaire, this.list)
        },
        onChangeList(list) {
            this.list = list
            this.pagination.currentPage = 1
            this.getEvaluationsReport(this.questionnaire, this.list)
        },
        onRefresh() {
            this.pagination.currentPage = 1
            this.getEvaluationsReport(this.questionnaire, this.list)
        },
        onChangeFilters() {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            this.timeout = setTimeout(() => {
                this.getEvaluationsReport(this.questionnaire, this.list)
            }, 1000)
        },
        onSearchName() {
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                this.getEvaluationsReport(this.questionnaire, this.list)
            }, 1000)
        },
        removeItemFromTable(itemId) {
            this.userList = this.tableItems.filter((tableItem) => tableItem.id !== itemId)
        },
    },
    created() {
        this.getQuestionnaireTitle()
        this.getEvaluationsReport(this.questionnaire, this.list)
    },

    destroyed() {
        clearInterval(this.timeout)
    },
    computed: {
        requestParameters() {
            return {
                per_page: this.pagination.perPage,
                page: this.pagination.currentPage,
                groups: this.filteredOccupationGroups,
                teams: this.filteredTeams,
                managers: this.filteredManagers,
                name: this.filteredName,
            }
        },
        filteredTeams() {
            return this.filtered.sections.map((section) => {
                return section.value
            })
        },
        filteredOccupationGroups() {
            return this.filtered.occupationGroups.map((group) => {
                return group.value
            })
        },
        filteredManagers() {
            return this.filtered.managers.map((manager) => {
                return manager.value
            })
        },
        filteredName() {
            if (this.filtered.searchName) {
                return this.filtered.searchName
            }
            return null
        },
        userList: {
            get() {
                return this.tableItems
            },
            set(value) {
                this.tableItems = value
            },
        },
    },
}
</script>

<style lang="scss" scoped>
$blue: #009ada;
.no-border {
    border: 0;
}
.container-evaluation-report {
    margin: 0.5rem;
}
.report-footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.list-link {
    font-size: 16px;
    color: #7f7f7f;
    font-weight: 500;
    text-decoration: none;
}
.list-link:hover {
    text-decoration: none;
}
.list-link.active {
    color: $blue;
    border-bottom: 2px solid #009ada;
}
.list-links-wrapper {
    margin-bottom: 10px;
}
.list-links-wrapper a {
    margin-right: 1.3rem;
}
.questionnaire-title {
    color: $blue;
}
.questionnaire-title-wrapper {
    margin: 20px 0;
}
.filters {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 0.75rem 2rem;
}
.filters > div {
    margin-right: 1rem;
}
.card {
    margin-bottom: 0 !important;
}

.search-input {
    width: 40em;
}

@media screen and (max-width: 1368px) {
    .search-input {
        width: 30em;
    }
}
@media screen and (max-width: 768px) {
    .search-input {
        width: 20em;
    }
}
</style>
